export const getJson = (key: string) => {
  const value = localStorage.getItem(key);
  let json;

  if (value) {
    try {
      json = JSON.parse(value);
    } catch (e) {
      localStorage.removeItem(key);
    }
  }

  return json;
};

export const setJson = (key: string, obj: any) => {
  try {
    localStorage.setItem(key, JSON.stringify(obj));
    return true;
  } catch (e) {
    return false;
  }
};

export const remove = (key: string) => localStorage.removeItem(key);
